import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboardConfig: {
    showAudienceChart: true,
    showContentEngagementBarGraph: true,
    showAudienceByGender: true,
    showContentViewBarGraph: true,
    showAverageWatchTimeChart: true,
    showEngagementRateChart: true,
    showContentApprovalTimeGraph: true,
    showSummaryAtPosition: "start",
  },
};

const dashboardConfigSlice = createSlice({
  name: "dashboardConfig",
  initialState,
  reducers: {
    setDashboardConfig: (state, action) => {
      state.dashboardConfig = action.payload;
    },
  },
});

export const { setDashboardConfig } = dashboardConfigSlice.actions;
export default dashboardConfigSlice.reducer;
